import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Form, Input } from 'antd';
import { updateAffiliateRequest } from '../redux/actions/update_affiliate.actions';

const mapStateToProps = state => ({
    current_affiliate: state.PlatformManagement.Manage_affiliates.current_affiliate,
}); const
    FormItem = Form.Item;

export default connect(mapStateToProps, null)(class AffiliateUpdate extends Component {
  handleAffiliateFields = ({ target: { name, value } }) => this.props.dispatch({ type: 'HANDLE_AFFILIATE_FIELDS', [name]: value });

  updateAffiliateField = ({ target: { name, value } }) => {
      this.props.dispatch(updateAffiliateRequest({ id: this.props.current_affiliate._id, name, value }));
  };

  render() {
      const {
          name, abbr, old_crm_affiliate_id, loans_affiliate_id,
      } = this.props.current_affiliate;
      return (
          <Fragment>
              <h3 style={{ textAlign: 'center' }}>
                  Update
                  {name}
                  {' '}
                  affiliate
              </h3>
              <Form>
                  <FormItem style={{ marginTop: 10 }} label="Name">
                      <Input
                          maxLength={20}
                          autoComplete="off"
                          name="name"
                          value={name}
                          style={{ marginTop: 10 }}
                          placeholder="Enter affiliate name"
                          onChange={this.handleAffiliateFields}
                          onBlur={this.updateAffiliateField}
                      />
                  </FormItem>
                  <FormItem style={{ marginTop: 20 }} label="Abbreviation">
                      <Input
                          maxLength={5}
                          autoComplete="off"
                          name="abbr"
                          value={abbr}
                          style={{ marginTop: 10 }}
                          placeholder="Enter affiliate abbreviation"
                          onChange={this.handleAffiliateFields}
                          onBlur={this.updateAffiliateField}
                      />
                  </FormItem>
                  <FormItem style={{ marginTop: 20 }} label="Old Crm Affiliate ID">
                      <Input
                          type="number"
                          name="old_crm_affiliate_id"
                          value={old_crm_affiliate_id}
                          style={{ marginTop: 10 }}
                          placeholder="Enter old CRM affiliate ID"
                          onChange={this.handleAffiliateFields}
                          onBlur={this.updateAffiliateField}
                      />
                  </FormItem>
                  <FormItem style={{ marginTop: 20 }} label="Loans Affiliate ID">
                      <Input
                          type="number"
                          name="loans_affiliate_id"
                          value={loans_affiliate_id}
                          style={{ marginTop: 10 }}
                          placeholder="Enter Loans CRM affiliate ID"
                          onChange={this.handleAffiliateFields}
                          onBlur={this.updateAffiliateField}
                      />
                  </FormItem>
              </Form>
          </Fragment>
      );
  }
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Manage_affiliates_update/components/AffiliateUpdate.js